import {
  Box,
  Button,
  ButtonGroup,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  TooltipProps,
  Typography,
  styled,
  tooltipClasses,
} from "@mui/material";
import styles from "../../styles/pages/user/content-buyer-notification.module.scss";
import React, { Fragment } from "react";
import DoubleCheckIcon from "../../ui/Icons/DoubleCheckIcon";
import BookmarkIcon from "../../ui/Icons/BookmarkIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
// import Image from 'next/image';
import assest from "../../json/assest";
import RemoveIcon from "../../ui/Icons/RemoveIcon";
import NotificationNoItemIcon from "../../ui/Icons/NotificationNoItemIcon";
import ArchiveNoItemicon from "../../ui/Icons/ArchiveNoItemicon";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  getAbsoluteImageURI,
  getStyledDateTime,
} from "../../lib/functions/utils.lib";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#F6F6F6",
    maxWidth: 220,
    borderRadius: "120px 100px 100px 0",
    padding: 0,
    minWidth: "74px",
    minHeight: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 0 -6px 15px !important",

    "& .MuiTypography-root": {
      fontWeight: "500",
      fontSize: "12px",
      color: "#000",
      textAlign: "center",
    },
  },
}));

const ContentbuyerNotificationTab = ({
  notifiactionsList,
  notifiactionsListIsLoading,
  updateNotificationSeen,
  updateNotificationArchive,
  updateNotificationReadAll,
  updateNotificationArchiveAll,
  updateNotificationDelete,
  updateNotificationDeleteAll,
  setFilterArchive,
  hasNextPage,
  fetchNextPage,
}) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setFilterArchive(newValue);
  };

  console.warn(notifiactionsList);

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="wrap"
        justifyContent="space-between"
        className={styles.notificationTabsHeader}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="All Notifications" {...a11yProps(0)} />
          <Tab label="Archive" {...a11yProps(1)} />
        </Tabs>
        {value == 0 ? (
          <ButtonGroup>
            <Button
              startIcon={<DoubleCheckIcon />}
              onClick={updateNotificationReadAll}
            >
              Mark all as read
            </Button>
            <Button
              startIcon={<BookmarkIcon />}
              onClick={updateNotificationArchiveAll}
            >
              Archive all
            </Button>
          </ButtonGroup>
        ) : (
          <ButtonGroup>
            <Button
              startIcon={<RemoveIcon />}
              onClick={updateNotificationDeleteAll}
            >
              Remove all
            </Button>
          </ButtonGroup>
        )}
      </Stack>
      <Paper elevation={0} className={styles.tabPanelPaper}>
        <TabPanel value={value} index={0}>
          {/* ====================================== */}
          {/* =========== NO ITEMS START =========== */}
          {/* ====================================== */}

          {/* <Stack className={styles.noItems}>
                        <NotificationNoItemIcon />
                        <Typography variant='body1'>You're all clear - no new notifications</Typography>
                    </Stack> */}

          {/* ====================================== */}
          {/* ============ NO ITEMS END ============ */}
          {/* ====================================== */}

          {notifiactionsListIsLoading ? (
            ""
          ) : notifiactionsList?.[0]?.length ? (
            <>
              <PerfectScrollbar>
                <List className={styles.notifiactionList}>
                  {notifiactionsList?.map((group, index) => (
                    <Fragment key={index}>
                      {group?.data?.data?.map((item, index) => {
                        return (
                          <ListItem key={index} className={styles.listStyled}>
                            <Grid
                              container
                              spacing={0}
                              className={styles.overlayBg}
                            >
                              <Grid item md={9}>
                                <Stack
                                  direction="row"
                                  flexWrap="wrap"
                                  className={styles.mediaLeft}
                                >
                                  <figure>
                                    <img
                                      src={getAbsoluteImageURI(item?.icon)}
                                      width="26"
                                      height="26"
                                      alt="icon"
                                    />
                                  </figure>
                                  <Box className={styles.mediaAddress}>
                                    <Typography variant="subtitle1">
                                      {item?.title}
                                    </Typography>
                                    {item?.old_value || item?.new_value ? (
                                      <List>
                                        <ListItem>
                                          From:
                                          {item?.old_value}
                                        </ListItem>
                                        <ListItem>
                                          To:
                                          {item?.new_value}
                                        </ListItem>
                                      </List>
                                    ) : (
                                      ""
                                    )}
                                    <Typography variant="caption">
                                      {getStyledDateTime(item?.updated_at)}
                                    </Typography>
                                  </Box>
                                </Stack>
                              </Grid>
                              <Grid item md={3}>
                                <Stack
                                  direction="row"
                                  flexWrap="wrap"
                                  justifyContent="flex-end"
                                  className={styles.mediaRight}
                                >
                                  {item?.seen ? (
                                    item?.archive ? (
                                      <HtmlTooltip
                                        title={
                                          <React.Fragment>
                                            <Typography color="inherit">
                                              Remove
                                            </Typography>
                                          </React.Fragment>
                                        }
                                        placement="top-start"
                                      >
                                        <img
                                          onClick={() =>
                                            updateNotificationDelete(item)
                                          }
                                          src={assest.crossGray}
                                          width={9}
                                          height={9}
                                          alt="icon"
                                        />
                                      </HtmlTooltip>
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          updateNotificationArchive(item)
                                        }
                                      >
                                        Archive
                                      </Button>
                                    )
                                  ) : (
                                    <Button
                                      onClick={() =>
                                        updateNotificationSeen(item)
                                      }
                                    >
                                      Mark as read
                                    </Button>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                          </ListItem>
                        );
                      })}
                    </Fragment>
                  ))}
                </List>
                {hasNextPage ? (
                  <Box className={styles.viewmoreBtnStyled}>
                    <Button onClick={fetchNextPage}>View more</Button>
                  </Box>
                ) : (
                  ""
                )}
              </PerfectScrollbar>
            </>
          ) : (
            <Stack className={styles.noItems}>
              <NotificationNoItemIcon />
              <Typography variant="body1">
                You're all clear - no new notifications
              </Typography>
            </Stack>
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {notifiactionsListIsLoading ? (
            ""
          ) : notifiactionsList?.[0]?.length ? (
            <>
              <PerfectScrollbar>
                <List className={styles.notifiactionList}>
                  {notifiactionsList?.map((group, index) => (
                    <Fragment key={index}>
                      {group?.data?.data?.map((item, index) => {
                        return (
                          <ListItem key={index} className={styles.listStyled}>
                            <Grid
                              container
                              spacing={0}
                              className={styles.overlayBg}
                            >
                              <Grid item md={9}>
                                <Stack
                                  direction="row"
                                  flexWrap="wrap"
                                  className={styles.mediaLeft}
                                >
                                  <figure>
                                    <img
                                      src={getAbsoluteImageURI(item?.icon)}
                                      width="26"
                                      height="26"
                                      alt="icon"
                                    />
                                  </figure>
                                  <Box className={styles.mediaAddress}>
                                    <Typography variant="subtitle1">
                                      {item?.title}
                                    </Typography>
                                    {item?.old_value || item?.new_value ? (
                                      <List>
                                        <ListItem>
                                          From:
                                          {item?.old_value}
                                        </ListItem>
                                        <ListItem>
                                          To:
                                          {item?.new_value}
                                        </ListItem>
                                      </List>
                                    ) : (
                                      ""
                                    )}
                                    <Typography variant="caption">
                                      {getStyledDateTime(item?.updated_at)}
                                    </Typography>
                                  </Box>
                                </Stack>
                              </Grid>
                              <Grid item md={3}>
                                <Stack
                                  direction="row"
                                  flexWrap="wrap"
                                  justifyContent="flex-end"
                                  className={styles.mediaRight}
                                >
                                  {item?.seen ? (
                                    item?.archive ? (
                                      <HtmlTooltip
                                        title={
                                          <React.Fragment>
                                            <Typography color="inherit">
                                              Remove
                                            </Typography>
                                          </React.Fragment>
                                        }
                                        placement="top-start"
                                      >
                                        <img
                                          onClick={() =>
                                            updateNotificationDelete(item)
                                          }
                                          src={assest.crossGray}
                                          width={9}
                                          height={9}
                                          alt="icon"
                                        />
                                      </HtmlTooltip>
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          updateNotificationArchive(item)
                                        }
                                      >
                                        Archive
                                      </Button>
                                    )
                                  ) : (
                                    <Button
                                      onClick={() =>
                                        updateNotificationSeen(item)
                                      }
                                    >
                                      Mark as read
                                    </Button>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                          </ListItem>
                        );
                      })}
                    </Fragment>
                  ))}
                </List>
                {hasNextPage ? (
                  <Box className={styles.viewmoreBtnStyled}>
                    <Button onClick={fetchNextPage}>View more</Button>
                  </Box>
                ) : (
                  ""
                )}
              </PerfectScrollbar>
            </>
          ) : (
            <Stack className={`${styles.noItems} ${styles.archivenoItems}`}>
              <ArchiveNoItemicon />
              <Typography variant="body1">
                No archived notifications found.
              </Typography>
            </Stack>
          )}

          {/* ====================================== */}
          {/* ============ NO ITEMS END ============ */}
          {/* ====================================== */}
        </TabPanel>
      </Paper>
    </>
  );
};

export default ContentbuyerNotificationTab;
